import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiCamera, FiFileText, FiCheck } = FiIcons;

function Navigation({ currentStep, setCurrentStep }) {
  const navigate = useNavigate();
  const location = useLocation();

  const steps = [
    { id: 'donor', label: 'Donor Info', icon: FiUser, path: '/donor' },
    { id: 'donation', label: 'Add Items', icon: FiCamera, path: '/donation' },
    { id: 'report', label: 'Generate Report', icon: FiFileText, path: '/report' }
  ];

  const handleStepClick = (step) => {
    setCurrentStep(step.id);
    navigate(step.path);
  };

  const getCurrentStepIndex = () => {
    return steps.findIndex(step => location.pathname === step.path);
  };

  const currentIndex = getCurrentStepIndex();

  return (
    <div className="border-b border-gray-200 bg-gray-50">
      <div className="flex">
        {steps.map((step, index) => {
          const isActive = location.pathname === step.path;
          const isCompleted = index < currentIndex;
          const isClickable = index <= currentIndex;

          return (
            <button
              key={step.id}
              onClick={() => isClickable && handleStepClick(step)}
              disabled={!isClickable}
              className={`
                flex-1 flex items-center justify-center py-4 px-6 text-sm font-medium
                border-b-2 transition-all duration-200
                ${isActive 
                  ? 'border-blue-500 text-blue-600 bg-blue-50' 
                  : isCompleted
                    ? 'border-green-500 text-green-600 bg-green-50 hover:bg-green-100'
                    : isClickable
                      ? 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                      : 'border-transparent text-gray-300 cursor-not-allowed'
                }
              `}
            >
              <div className="flex items-center space-x-2">
                <div className={`
                  w-6 h-6 rounded-full flex items-center justify-center text-xs
                  ${isCompleted 
                    ? 'bg-green-500 text-white' 
                    : isActive
                      ? 'bg-blue-500 text-white'
                      : 'bg-gray-300 text-gray-600'
                  }
                `}>
                  {isCompleted ? (
                    <SafeIcon icon={FiCheck} className="w-3 h-3" />
                  ) : (
                    <SafeIcon icon={step.icon} className="w-3 h-3" />
                  )}
                </div>
                <span className="hidden sm:inline">{step.label}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default Navigation;